// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =====================================================
   General Layout & Container
   ===================================================== */

   .comment-monitoring {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    padding: 10px;
    box-sizing: border-box;
    position: relative;
    width: 99vw;
    height: 100vh;
    padding-left: 15%; /* Ensures columns don't go behind the sidebar */
}

.comment-monitoring h1 {
    margin-bottom: 0px;
    font-size: 2.0rem;
    text-align: center;
    color: #65ccb7;
    margin-top: -40px;
}

/* =====================================================
   Forms & Inputs
   ===================================================== */

.comment-monitoring-form {
    position: relative;
    top: 0;
    z-index: 20;
    background-color: white;
    padding: 30px;
    border-radius: 10px;
    width: 80%;
    max-width: 700px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    margin-bottom: 20px;
    transition: all 0.3s ease-in-out;
}

.comment-monitoring-form.collapsed {
    display: none;
}

.comment-monitoring-form.hidden {
    max-height: 0;
    opacity: 0;
    padding: 0;
}

.comment-monitoring-form-group {
    font-weight: bold;
    color: #65ccb7;
    display: flex;
    flex-direction: column; /* Stack the input and label vertically */
    width: 100%;
}
  .comment-monitoring-platform-icon {
    display: block;
    margin-bottom: 20px; /* Adds space after the platform text */
  }
  
  .detected-platform-text {
    margin-left: 0px; /* Adds spacing between the icon and the text */
    font-weight: bold; /* Optional: If you want to emphasize the text */
  }
  
  
  .comment-monitoring-form-group input {
    margin-bottom: 15px; /* Adds space between input fields */
  }
  
  .comment-monitoring-form-group label {
    margin-bottom: 5px; /* Adds a little space below labels */
  }
  

.comment-monitoring-form input,
.comment-monitoring-form select {
    width: 100%;
    padding: 15px;
    border: 1px solid #65ccb7;
    border-radius: 8px;
    font-size: 1.0rem;
    color: #333;
    outline: none;
    
}

.comment-monitoring-form input:focus,
.comment-monitoring-form select:focus {
    border-color: #45a98c;
    box-shadow: 0 0 8px rgba(69, 169, 140, 0.6);
}

/* =====================================================
   Buttons
   ===================================================== */

.comment-monitoring-search-button {
    background-color: #65ccb7;
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 8px;
    cursor: pointer;
    font-size: 1.0rem;
    font-weight: bold;
    transition: background-color 0.3s ease;
    margin-left: 0px;
    margin-top: 15px;
}

.comment-monitoring-search-button:hover {
    background-color: #45a98c;
}

/* Toggle Button */
.toggle-button {
    position: fixed;
    top: 20px;
    right: 20px;
    background-color: #65ccb7;
    color: white;
    border: none;
    padding: 10px 15px;
    border-radius: 50%;
    cursor: pointer;
    font-size: 1.5rem;
    font-weight: bold;
    transition: background-color 0.3s ease;
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    z-index: 1000;
}

.toggle-button:hover {
    background-color: #4aaea0;
}
.delete-column-button {
    background-color: transparent;
    border: none;
    font-size: 1.5rem; /* Adjust the size of the "X" */
    color: #d9534f; /* Red color for delete action */
    cursor: pointer;
    padding: 5px 10px;
    transition: color 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .delete-column-button:hover {
    color: #c9302c; /* Darker red on hover */
  }
  
  .delete-column-button .cross-button {
    font-weight: bold;
    font-size: 20px;
    margin-right: 20px;
  }
  

/* =====================================================
   Columns & Post Containers
   ===================================================== */

/* Wrapper for horizontal scrolling */
.comment-monitoring-columns-wrapper {
    display: flex;
    gap: 15px;
    padding: 10px;
    overflow-x: auto;
    width: 100%;
    height: auto;
}

.comment-monitoring-column {
    background-color: #ffffff;
    border: 1px solid #ddd;
    border-radius: 10px;
    width: 25%;
    flex-shrink: 0;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    overflow: hidden;
    z-index: 10;
    word-break: break-word;
    overflow-wrap: break-word;
    max-width: 100%;
}

/* Header Card */
.comment-monitoring-header-card {
    background-color: #f1f1f1;
    padding: 15px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    border-radius: 10px 10px 0 0;
    text-align: center;
    display: flex;
    flex-direction: column;
    gap: 10px;
    align-items: center;
    position: relative;
}





/* Input inside the header */
.comment-monitoring-header-card input {
    width: 90%;
    padding: 8px;
    border: 1px solid #65ccb7;
    border-radius: 5px;
    font-size: 1rem;
    outline: none;
    transition: border-color 0.3s;
}

.comment-monitoring-header-card input:focus {
    border-color: #45a98c;
}

/* =====================================================
   Postcards & Platform-Specific Styling
   ===================================================== */

.comment-monitoring-postcard {
    border-radius: 10px;
    margin-bottom: 15px;
    padding: 15px;
    display: flex;
    flex-direction: column;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    position: relative;
    color: white;
}

/* Platform-Specific Colors */
.comment-monitoring-postcard.facebook {
    background: linear-gradient(90deg, #4267b2, #5fb9e2);
}

.comment-monitoring-postcard.instagram {
    background: linear-gradient(45deg, #774adf, #9648be, #bc4596, #d8447a, #e94369, #ef4363, #f07f52, #f2c141);
}

.comment-monitoring-postcard.tiktok {
    background: linear-gradient(45deg, #9300c7, #69c9d0);
}

.comment-monitoring-postcard.unknown {
    background-color: #f9f9f9;
    color: #333;
}

/* =====================================================
   Scrollbars
   ===================================================== */

.comment-monitoring-columns-wrapper::-webkit-scrollbar {
    height: 8px;
}

.comment-monitoring-columns-wrapper::-webkit-scrollbar-thumb {
    background: #65ccb7;
    border-radius: 5px;
}

.comment-monitoring-posts-wrapper {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 10px;
    overflow-x: hidden;
    overflow-y: scroll;
    max-height: 790px;
}

.comment-monitoring-posts-wrapper::-webkit-scrollbar {
    width: 6px;
}

.comment-monitoring-posts-wrapper::-webkit-scrollbar-thumb {
    background: #65ccb7;
    border-radius: 4px;
}

/* =====================================================
   Loading Overlay
   ===================================================== */

/* Container for loading screen */
.loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    z-index: 9999;
  }

  .loading-container {
    background-color: white;
    padding: 30px;
    border-radius: 10px;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 15px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }

  /* Loader animation */
.loader {
    width: 60px;
    aspect-ratio: 1;
    --_g: no-repeat radial-gradient(farthest-side, #000 90%, #0000);
    background: var(--_g), var(--_g), var(--_g);
    background-size: 25% 25%;
    animation: l17 1s infinite;
  }
  
  @keyframes l17 {
    0% {
      background-position: 0% -100%, 50% -100%, 100% -100%;
    }
    16.67% {
      background-position: 0% 50%, 50% -100%, 100% -100%;
    }
    33.33% {
      background-position: 0% 50%, 50% 50%, 100% -100%;
    }
    45%, 55% {
      background-position: 0% 50%, 50% 50%, 100% 50%;
    }
    66.67% {
      background-position: 0% 200%, 50% 50%, 100% 50%;
    }
    83.33% {
      background-position: 0% 200%, 50% 200%, 100% 50%;
    }
    100% {
      background-position: 0% 200%, 50% 200%, 100% 200%;
    }
  }
  
  /* Text below the loader */
  .loading-text {
    font-size: 16px;
    color: #333;
  }

.spinning-logo {
    width: 100px;
    height: 100px;
    animation: spinOnAxis 2s linear infinite;
    transform-origin: center center;
}

@keyframes spinOnAxis {
    0% {
      transform: rotate(0deg); /* Initial position */
    }
    100% {
      transform: rotate(360deg); /* Full 360-degree rotation */
    }
  }
  
.loading-text {
    color: white;
    font-size: 18px;
    margin-top: 10px;
}

.loading-logs {
    font-size: 14px;
    color: white;
    margin-top: 10px;
  }

/* date fileters */
.comment-monitoring-date-filter {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 5px; /* Reduce spacing between elements */
    justify-content: space-between;
    width: 87%;
    padding: 5px;
    background: #d2d2d2;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    flex-wrap: wrap; /* Ensures responsiveness */
    margin-left: 7px;
}

.date-inputs {
    display: flex;
    gap: 10px; /* Space between the "From" and "To" inputs */
  }
  



.comment-monitoring-date-filter label {
    font-size: 0.8rem; /* Reduce font size */
    color: #333;
    font-weight: bold;
    margin-right: 5px;
}

.comment-monitoring-date-filter input {
    flex: 1 1;
    padding: 5px; /* Reduce padding */
    border: 1px solid #65ccb7;
    border-radius: 5px;
    font-size: 0.8rem; /* Reduce font size */
    outline: none;
    transition: border-color 0.3s;
    max-width: 120px; /* Set a max width to prevent overflow */
}

.comment-monitoring-date-filter input:focus {
    border-color: #45a98c;
    box-shadow: 0 0 5px rgba(69, 169, 140, 0.5);
}

/* Style the Reset button */
.reset-button {
    background-color: #65ccb7;
    color: white;
    border: none;
    padding: 5px 10px; /* Reduce button size */
    border-radius: 5px;
    cursor: pointer;
    font-size: 0.8rem; /* Reduce font size */
    font-weight: bold;
    transition: background-color 0.3s ease;
    margin-left: 20px;
    margin-top: 5px;
}

.reset-button:hover {
    background-color: #45a98c;
}


.search-term-text {
    font-size: 12px;
    color: #888;
    margin-top: 5px;
  }
  

  /* 28 feb 2024  */

  .comment-monitoring-div h2 {
    font-size: 1.5rem;
    color: #65ccb7;
    font-weight: bold;
  }

  /* 28 feb  */
  .comment-monitoring-platform-icon {
    display: flex;
    align-items: center;
  }
  
  .detected-platform-text {
    margin-left: 0px;
    font-weight: bold;
    margin-bottom: 5px;
  }
  
  .detected-platform-text.unsupported {
    color: red;
  }

  .comment-monitoring-div {
    margin-top: 0px;
    align-self: center;
    /* margin-left: 20px; */
  }
  
  .comment-monitoring-div h2 {
    font-size: 1.5rem;
    color: #65ccb7;
    font-weight: bold;
  }
  
  .supported-platform-icons {
    display: flex;
    gap: 20px;
    margin-top: 10px;
    margin-left: 55px;
  }`, "",{"version":3,"sources":["webpack://./src/comment-monitoring/comment-monitoring.css"],"names":[],"mappings":"AAAA;;0DAE0D;;GAEvD;IACC,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,2BAA2B;IAC3B,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,iBAAiB,EAAE,gDAAgD;AACvE;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,iBAAiB;AACrB;;AAEA;;0DAE0D;;AAE1D;IACI,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,uBAAuB;IACvB,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,gBAAgB;IAChB,wCAAwC;IACxC,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,UAAU;IACV,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,sBAAsB,EAAE,yCAAyC;IACjE,WAAW;AACf;EACE;IACE,cAAc;IACd,mBAAmB,EAAE,uCAAuC;EAC9D;;EAEA;IACE,gBAAgB,EAAE,+CAA+C;IACjE,iBAAiB,EAAE,gDAAgD;EACrE;;;EAGA;IACE,mBAAmB,EAAE,oCAAoC;EAC3D;;EAEA;IACE,kBAAkB,EAAE,qCAAqC;EAC3D;;;AAGF;;IAEI,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,WAAW;IACX,aAAa;;AAEjB;;AAEA;;IAEI,qBAAqB;IACrB,2CAA2C;AAC/C;;AAEA;;0DAE0D;;AAE1D;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,sCAAsC;IACtC,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,kBAAkB;AAClB;IACI,eAAe;IACf,SAAS;IACT,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,sCAAsC;IACtC,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,wCAAwC;IACxC,aAAa;AACjB;;AAEA;IACI,yBAAyB;AAC7B;AACA;IACI,6BAA6B;IAC7B,YAAY;IACZ,iBAAiB,EAAE,+BAA+B;IAClD,cAAc,EAAE,gCAAgC;IAChD,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,cAAc,EAAE,wBAAwB;EAC1C;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,kBAAkB;EACpB;;;AAGF;;0DAE0D;;AAE1D,qCAAqC;AACrC;IACI,aAAa;IACb,SAAS;IACT,aAAa;IACb,gBAAgB;IAChB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,mBAAmB;IACnB,UAAU;IACV,cAAc;IACd,wCAAwC;IACxC,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,WAAW;IACX,sBAAsB;IACtB,yBAAyB;IACzB,eAAe;AACnB;;AAEA,gBAAgB;AAChB;IACI,yBAAyB;IACzB,aAAa;IACb,yCAAyC;IACzC,4BAA4B;IAC5B,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;IACnB,kBAAkB;AACtB;;;;;;AAMA,4BAA4B;AAC5B;IACI,UAAU;IACV,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;;0DAE0D;;AAE1D;IACI,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,wCAAwC;IACxC,kBAAkB;IAClB,YAAY;AAChB;;AAEA,6BAA6B;AAC7B;IACI,oDAAoD;AACxD;;AAEA;IACI,0GAA0G;AAC9G;;AAEA;IACI,oDAAoD;AACxD;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;;0DAE0D;;AAE1D;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;;0DAE0D;;AAE1D,iCAAiC;AACjC;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,aAAa;EACf;;EAEA;IACE,uBAAuB;IACvB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,wCAAwC;EAC1C;;EAEA,qBAAqB;AACvB;IACI,WAAW;IACX,eAAe;IACf,+DAA+D;IAC/D,2CAA2C;IAC3C,wBAAwB;IACxB,0BAA0B;EAC5B;;EAEA;IACE;MACE,oDAAoD;IACtD;IACA;MACE,kDAAkD;IACpD;IACA;MACE,gDAAgD;IAClD;IACA;MACE,8CAA8C;IAChD;IACA;MACE,+CAA+C;IACjD;IACA;MACE,gDAAgD;IAClD;IACA;MACE,iDAAiD;IACnD;EACF;;EAEA,0BAA0B;EAC1B;IACE,eAAe;IACf,WAAW;EACb;;AAEF;IACI,YAAY;IACZ,aAAa;IACb,wCAAwC;IACxC,+BAA+B;AACnC;;AAEA;IACI;MACE,uBAAuB,EAAE,qBAAqB;IAChD;IACA;MACE,yBAAyB,EAAE,6BAA6B;IAC1D;EACF;;AAEF;IACI,YAAY;IACZ,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,gBAAgB;EAClB;;AAEF,kBAAkB;AAClB;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ,EAAE,oCAAoC;IAC9C,8BAA8B;IAC9B,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,wCAAwC;IACxC,eAAe,EAAE,2BAA2B;IAC5C,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS,EAAE,6CAA6C;EAC1D;;;;;AAKF;IACI,iBAAiB,EAAE,qBAAqB;IACxC,WAAW;IACX,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,SAAO;IACP,YAAY,EAAE,mBAAmB;IACjC,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB,EAAE,qBAAqB;IACxC,aAAa;IACb,6BAA6B;IAC7B,gBAAgB,EAAE,wCAAwC;AAC9D;;AAEA;IACI,qBAAqB;IACrB,2CAA2C;AAC/C;;AAEA,2BAA2B;AAC3B;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,iBAAiB,EAAE,uBAAuB;IAC1C,kBAAkB;IAClB,eAAe;IACf,iBAAiB,EAAE,qBAAqB;IACxC,iBAAiB;IACjB,sCAAsC;IACtC,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;;AAGA;IACI,eAAe;IACf,WAAW;IACX,eAAe;EACjB;;;EAGA,iBAAiB;;EAEjB;IACE,iBAAiB;IACjB,cAAc;IACd,iBAAiB;EACnB;;EAEA,YAAY;EACZ;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,SAAS;IACT,gBAAgB;IAChB,iBAAiB;EACnB","sourcesContent":["/* =====================================================\r\n   General Layout & Container\r\n   ===================================================== */\r\n\r\n   .comment-monitoring {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: flex-start;\r\n    padding: 10px;\r\n    box-sizing: border-box;\r\n    position: relative;\r\n    width: 99vw;\r\n    height: 100vh;\r\n    padding-left: 15%; /* Ensures columns don't go behind the sidebar */\r\n}\r\n\r\n.comment-monitoring h1 {\r\n    margin-bottom: 0px;\r\n    font-size: 2.0rem;\r\n    text-align: center;\r\n    color: #65ccb7;\r\n    margin-top: -40px;\r\n}\r\n\r\n/* =====================================================\r\n   Forms & Inputs\r\n   ===================================================== */\r\n\r\n.comment-monitoring-form {\r\n    position: relative;\r\n    top: 0;\r\n    z-index: 20;\r\n    background-color: white;\r\n    padding: 30px;\r\n    border-radius: 10px;\r\n    width: 80%;\r\n    max-width: 700px;\r\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\r\n    margin-bottom: 20px;\r\n    transition: all 0.3s ease-in-out;\r\n}\r\n\r\n.comment-monitoring-form.collapsed {\r\n    display: none;\r\n}\r\n\r\n.comment-monitoring-form.hidden {\r\n    max-height: 0;\r\n    opacity: 0;\r\n    padding: 0;\r\n}\r\n\r\n.comment-monitoring-form-group {\r\n    font-weight: bold;\r\n    color: #65ccb7;\r\n    display: flex;\r\n    flex-direction: column; /* Stack the input and label vertically */\r\n    width: 100%;\r\n}\r\n  .comment-monitoring-platform-icon {\r\n    display: block;\r\n    margin-bottom: 20px; /* Adds space after the platform text */\r\n  }\r\n  \r\n  .detected-platform-text {\r\n    margin-left: 0px; /* Adds spacing between the icon and the text */\r\n    font-weight: bold; /* Optional: If you want to emphasize the text */\r\n  }\r\n  \r\n  \r\n  .comment-monitoring-form-group input {\r\n    margin-bottom: 15px; /* Adds space between input fields */\r\n  }\r\n  \r\n  .comment-monitoring-form-group label {\r\n    margin-bottom: 5px; /* Adds a little space below labels */\r\n  }\r\n  \r\n\r\n.comment-monitoring-form input,\r\n.comment-monitoring-form select {\r\n    width: 100%;\r\n    padding: 15px;\r\n    border: 1px solid #65ccb7;\r\n    border-radius: 8px;\r\n    font-size: 1.0rem;\r\n    color: #333;\r\n    outline: none;\r\n    \r\n}\r\n\r\n.comment-monitoring-form input:focus,\r\n.comment-monitoring-form select:focus {\r\n    border-color: #45a98c;\r\n    box-shadow: 0 0 8px rgba(69, 169, 140, 0.6);\r\n}\r\n\r\n/* =====================================================\r\n   Buttons\r\n   ===================================================== */\r\n\r\n.comment-monitoring-search-button {\r\n    background-color: #65ccb7;\r\n    color: white;\r\n    border: none;\r\n    padding: 10px 20px;\r\n    border-radius: 8px;\r\n    cursor: pointer;\r\n    font-size: 1.0rem;\r\n    font-weight: bold;\r\n    transition: background-color 0.3s ease;\r\n    margin-left: 0px;\r\n    margin-top: 15px;\r\n}\r\n\r\n.comment-monitoring-search-button:hover {\r\n    background-color: #45a98c;\r\n}\r\n\r\n/* Toggle Button */\r\n.toggle-button {\r\n    position: fixed;\r\n    top: 20px;\r\n    right: 20px;\r\n    background-color: #65ccb7;\r\n    color: white;\r\n    border: none;\r\n    padding: 10px 15px;\r\n    border-radius: 50%;\r\n    cursor: pointer;\r\n    font-size: 1.5rem;\r\n    font-weight: bold;\r\n    transition: background-color 0.3s ease;\r\n    width: 50px;\r\n    height: 50px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\r\n    z-index: 1000;\r\n}\r\n\r\n.toggle-button:hover {\r\n    background-color: #4aaea0;\r\n}\r\n.delete-column-button {\r\n    background-color: transparent;\r\n    border: none;\r\n    font-size: 1.5rem; /* Adjust the size of the \"X\" */\r\n    color: #d9534f; /* Red color for delete action */\r\n    cursor: pointer;\r\n    padding: 5px 10px;\r\n    transition: color 0.3s ease;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n  }\r\n  \r\n  .delete-column-button:hover {\r\n    color: #c9302c; /* Darker red on hover */\r\n  }\r\n  \r\n  .delete-column-button .cross-button {\r\n    font-weight: bold;\r\n    font-size: 20px;\r\n    margin-right: 20px;\r\n  }\r\n  \r\n\r\n/* =====================================================\r\n   Columns & Post Containers\r\n   ===================================================== */\r\n\r\n/* Wrapper for horizontal scrolling */\r\n.comment-monitoring-columns-wrapper {\r\n    display: flex;\r\n    gap: 15px;\r\n    padding: 10px;\r\n    overflow-x: auto;\r\n    width: 100%;\r\n    height: auto;\r\n}\r\n\r\n.comment-monitoring-column {\r\n    background-color: #ffffff;\r\n    border: 1px solid #ddd;\r\n    border-radius: 10px;\r\n    width: 25%;\r\n    flex-shrink: 0;\r\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\r\n    display: flex;\r\n    flex-direction: column;\r\n    overflow: hidden;\r\n    z-index: 10;\r\n    word-break: break-word;\r\n    overflow-wrap: break-word;\r\n    max-width: 100%;\r\n}\r\n\r\n/* Header Card */\r\n.comment-monitoring-header-card {\r\n    background-color: #f1f1f1;\r\n    padding: 15px;\r\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\r\n    border-radius: 10px 10px 0 0;\r\n    text-align: center;\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 10px;\r\n    align-items: center;\r\n    position: relative;\r\n}\r\n\r\n\r\n\r\n\r\n\r\n/* Input inside the header */\r\n.comment-monitoring-header-card input {\r\n    width: 90%;\r\n    padding: 8px;\r\n    border: 1px solid #65ccb7;\r\n    border-radius: 5px;\r\n    font-size: 1rem;\r\n    outline: none;\r\n    transition: border-color 0.3s;\r\n}\r\n\r\n.comment-monitoring-header-card input:focus {\r\n    border-color: #45a98c;\r\n}\r\n\r\n/* =====================================================\r\n   Postcards & Platform-Specific Styling\r\n   ===================================================== */\r\n\r\n.comment-monitoring-postcard {\r\n    border-radius: 10px;\r\n    margin-bottom: 15px;\r\n    padding: 15px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\r\n    position: relative;\r\n    color: white;\r\n}\r\n\r\n/* Platform-Specific Colors */\r\n.comment-monitoring-postcard.facebook {\r\n    background: linear-gradient(90deg, #4267b2, #5fb9e2);\r\n}\r\n\r\n.comment-monitoring-postcard.instagram {\r\n    background: linear-gradient(45deg, #774adf, #9648be, #bc4596, #d8447a, #e94369, #ef4363, #f07f52, #f2c141);\r\n}\r\n\r\n.comment-monitoring-postcard.tiktok {\r\n    background: linear-gradient(45deg, #9300c7, #69c9d0);\r\n}\r\n\r\n.comment-monitoring-postcard.unknown {\r\n    background-color: #f9f9f9;\r\n    color: #333;\r\n}\r\n\r\n/* =====================================================\r\n   Scrollbars\r\n   ===================================================== */\r\n\r\n.comment-monitoring-columns-wrapper::-webkit-scrollbar {\r\n    height: 8px;\r\n}\r\n\r\n.comment-monitoring-columns-wrapper::-webkit-scrollbar-thumb {\r\n    background: #65ccb7;\r\n    border-radius: 5px;\r\n}\r\n\r\n.comment-monitoring-posts-wrapper {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 10px;\r\n    padding: 10px;\r\n    overflow-x: hidden;\r\n    overflow-y: scroll;\r\n    max-height: 790px;\r\n}\r\n\r\n.comment-monitoring-posts-wrapper::-webkit-scrollbar {\r\n    width: 6px;\r\n}\r\n\r\n.comment-monitoring-posts-wrapper::-webkit-scrollbar-thumb {\r\n    background: #65ccb7;\r\n    border-radius: 4px;\r\n}\r\n\r\n/* =====================================================\r\n   Loading Overlay\r\n   ===================================================== */\r\n\r\n/* Container for loading screen */\r\n.loading-overlay {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    background-color: rgba(0, 0, 0, 0.5);\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    flex-direction: column;\r\n    z-index: 9999;\r\n  }\r\n\r\n  .loading-container {\r\n    background-color: white;\r\n    padding: 30px;\r\n    border-radius: 10px;\r\n    text-align: center;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    gap: 15px;\r\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\r\n  }\r\n\r\n  /* Loader animation */\r\n.loader {\r\n    width: 60px;\r\n    aspect-ratio: 1;\r\n    --_g: no-repeat radial-gradient(farthest-side, #000 90%, #0000);\r\n    background: var(--_g), var(--_g), var(--_g);\r\n    background-size: 25% 25%;\r\n    animation: l17 1s infinite;\r\n  }\r\n  \r\n  @keyframes l17 {\r\n    0% {\r\n      background-position: 0% -100%, 50% -100%, 100% -100%;\r\n    }\r\n    16.67% {\r\n      background-position: 0% 50%, 50% -100%, 100% -100%;\r\n    }\r\n    33.33% {\r\n      background-position: 0% 50%, 50% 50%, 100% -100%;\r\n    }\r\n    45%, 55% {\r\n      background-position: 0% 50%, 50% 50%, 100% 50%;\r\n    }\r\n    66.67% {\r\n      background-position: 0% 200%, 50% 50%, 100% 50%;\r\n    }\r\n    83.33% {\r\n      background-position: 0% 200%, 50% 200%, 100% 50%;\r\n    }\r\n    100% {\r\n      background-position: 0% 200%, 50% 200%, 100% 200%;\r\n    }\r\n  }\r\n  \r\n  /* Text below the loader */\r\n  .loading-text {\r\n    font-size: 16px;\r\n    color: #333;\r\n  }\r\n\r\n.spinning-logo {\r\n    width: 100px;\r\n    height: 100px;\r\n    animation: spinOnAxis 2s linear infinite;\r\n    transform-origin: center center;\r\n}\r\n\r\n@keyframes spinOnAxis {\r\n    0% {\r\n      transform: rotate(0deg); /* Initial position */\r\n    }\r\n    100% {\r\n      transform: rotate(360deg); /* Full 360-degree rotation */\r\n    }\r\n  }\r\n  \r\n.loading-text {\r\n    color: white;\r\n    font-size: 18px;\r\n    margin-top: 10px;\r\n}\r\n\r\n.loading-logs {\r\n    font-size: 14px;\r\n    color: white;\r\n    margin-top: 10px;\r\n  }\r\n\r\n/* date fileters */\r\n.comment-monitoring-date-filter {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    gap: 5px; /* Reduce spacing between elements */\r\n    justify-content: space-between;\r\n    width: 87%;\r\n    padding: 5px;\r\n    background: #d2d2d2;\r\n    border-radius: 8px;\r\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n    flex-wrap: wrap; /* Ensures responsiveness */\r\n    margin-left: 7px;\r\n}\r\n\r\n.date-inputs {\r\n    display: flex;\r\n    gap: 10px; /* Space between the \"From\" and \"To\" inputs */\r\n  }\r\n  \r\n\r\n\r\n\r\n.comment-monitoring-date-filter label {\r\n    font-size: 0.8rem; /* Reduce font size */\r\n    color: #333;\r\n    font-weight: bold;\r\n    margin-right: 5px;\r\n}\r\n\r\n.comment-monitoring-date-filter input {\r\n    flex: 1;\r\n    padding: 5px; /* Reduce padding */\r\n    border: 1px solid #65ccb7;\r\n    border-radius: 5px;\r\n    font-size: 0.8rem; /* Reduce font size */\r\n    outline: none;\r\n    transition: border-color 0.3s;\r\n    max-width: 120px; /* Set a max width to prevent overflow */\r\n}\r\n\r\n.comment-monitoring-date-filter input:focus {\r\n    border-color: #45a98c;\r\n    box-shadow: 0 0 5px rgba(69, 169, 140, 0.5);\r\n}\r\n\r\n/* Style the Reset button */\r\n.reset-button {\r\n    background-color: #65ccb7;\r\n    color: white;\r\n    border: none;\r\n    padding: 5px 10px; /* Reduce button size */\r\n    border-radius: 5px;\r\n    cursor: pointer;\r\n    font-size: 0.8rem; /* Reduce font size */\r\n    font-weight: bold;\r\n    transition: background-color 0.3s ease;\r\n    margin-left: 20px;\r\n    margin-top: 5px;\r\n}\r\n\r\n.reset-button:hover {\r\n    background-color: #45a98c;\r\n}\r\n\r\n\r\n.search-term-text {\r\n    font-size: 12px;\r\n    color: #888;\r\n    margin-top: 5px;\r\n  }\r\n  \r\n\r\n  /* 28 feb 2024  */\r\n\r\n  .comment-monitoring-div h2 {\r\n    font-size: 1.5rem;\r\n    color: #65ccb7;\r\n    font-weight: bold;\r\n  }\r\n\r\n  /* 28 feb  */\r\n  .comment-monitoring-platform-icon {\r\n    display: flex;\r\n    align-items: center;\r\n  }\r\n  \r\n  .detected-platform-text {\r\n    margin-left: 0px;\r\n    font-weight: bold;\r\n    margin-bottom: 5px;\r\n  }\r\n  \r\n  .detected-platform-text.unsupported {\r\n    color: red;\r\n  }\r\n\r\n  .comment-monitoring-div {\r\n    margin-top: 0px;\r\n    align-self: center;\r\n    /* margin-left: 20px; */\r\n  }\r\n  \r\n  .comment-monitoring-div h2 {\r\n    font-size: 1.5rem;\r\n    color: #65ccb7;\r\n    font-weight: bold;\r\n  }\r\n  \r\n  .supported-platform-icons {\r\n    display: flex;\r\n    gap: 20px;\r\n    margin-top: 10px;\r\n    margin-left: 55px;\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
